module.exports = __webpack_public_path__ + "img/PL09681.06b66665.svg";